import {TypeEvenement} from '../../shared/models/type-evenement.model';
import {NouvelEvenementDto} from './nouvel-evenement.dto';

export class DeclarerEvenementDto {
	nouveauxEvenements: NouvelEvenementDto[];
	typeEvenement: TypeEvenement;
	loginDemandeur: string;

	constructor(
		nouveauxEvenements: NouvelEvenementDto[],
		typeEvenement: TypeEvenement,
		loginDemandeur: string) {
		this.nouveauxEvenements = nouveauxEvenements;
		this.typeEvenement = typeEvenement;
		this.loginDemandeur = loginDemandeur;
	}
}
